module.exports = __webpack_public_path__ + "static/media/background2.25d5f08d.jpg";